<template>
    <div class="modal fade" id="assignOrderModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
        <div class="modal-dialog modal-lg">
            <div class="modal-content bg-white">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <template v-if="action==='reassign'">
                            Task Reassign
                        </template>
                        <template v-else>
                            Task Assign
                        </template>
                    </h5>
                    <!-- <button type="button" class="btn-close" @click="hideModal"></button> -->
                </div>
                <div class="modal-body">
                    <form class="row g-3">
                        <div class="col-md-4">
                            <label for="order_id" class="form-label">Order ID</label>
                            <input
                                type="text"
                                class="form-control disabled"
                                id="order_id"
                                disabled
                                v-model="orderData.order_number"
                            />
                        </div>
                        <div class="col-md-4">
                            <label for="customer_name" class="form-label">Client Name</label>
                            <input
                                type="text"
                                class="form-control disabled"
                                id="customer_name"
                                disabled
                                v-model="orderData.customer.name"
                            />
                        </div>
                        <div class="col-md-4">
                            <label for="phone_number" class="form-label">Mobile Number</label>
                            <input
                                type="text"
                                class="form-control disabled"
                                id="phone_number"
                                disabled
                                v-model="orderData.customer.phone_number"
                            />
                        </div>
                        <div class="col-md-4">
                            <label for="email" class="form-label">Email</label>
                            <input
                                type="text"
                                class="form-control disabled"
                                id="email"
                                disabled
                                v-model="orderData.customer.email"
                            />
                        </div>
                        <div class="col-md-8">
                            <label for="address" class="form-label">Address</label>
                            <input
                                type="text"
                                class="form-control disabled"
                                id="address"
                                disabled
                                v-model="orderData.service_address"
                            />
                        </div>
                        <div class="col-md-12">
                            <hr/>
                        </div>
                        <div class="col-md-3">
                            <label for="assign_date" class="form-label">Assign Date <span class="text-danger">*</span></label>
                            <BookingDatePicker
                                v-model="orderData.service_date"
                                :format="'dd-MM-yyyy'"
                                :time-picker="false"
                                :auto-apply="true"
                            />
                        </div>
                        <div class="col-md-3">
                            <label for="assign_date" class="form-label">Assign Time <span class="text-danger">*</span></label>
                            <!-- <VueDatePicker
                                v-model="orderData.service_time"
                                time-picker :is-24="false"
                                :clearable="false"
                                :minutes-grid-increment="10"
                                :minutes-increment="15"
                            >
                                <template #input-icon>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clock-11 hm-time-icons"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 9.5 8"/></svg>
                                </template>
                            </VueDatePicker> -->
                            <TimePicker v-model="orderData.service_time" placeholder="Select Time" />
                        </div>
                        <div class="col-md-6">
                            <label for="assign_handyman" class="form-label">Task Assign To <span class="text-danger">*</span></label>
                            <VueSelect
                                v-model="orderData.handyman_id"
                                :items="handymanList"
                                :multiple="true"
                                :placeholder="'Select Handyman'"
                                @onSelectOption="onSelectHandyman"
                            ></VueSelect>
                            <small v-if="handymanList.length === 0" class="text-danger">Please select valid assign date and time for task.</small>
                        </div>
                        <div class="col-md-6">
                            <div class="form-check form-check-inline">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="assign_duration"
                                    id="hours"
                                    value="hours"
                                    v-model="orderData.service_type"
                                >
                                <label class="form-check-label" for="hours">Time Duration (In Hours)</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input
                                    class="form-check-input"
                                    type="radio"
                                    name="assign_duration"
                                    id="full_day"
                                    value="full_day"
                                    v-model="orderData.service_type"
                                >
                                <label class="form-check-label" for="full_day">Full Day</label>
                            </div>
                            <input
                                type="number"
                                class="form-control"
                                id="assign_duration"
                                :class="{'disabled': orderData.service_type === 'full_day'}"
                                :disabled="orderData.service_type === 'full_day'"
                                v-model="orderData.service_duration"
                            />
                            <small v-if="orderData.service_duration < 1" class="text-danger">Please enter minimum 1 hour.</small>
                        </div>
                        <div class="col-md-6">
                            <label for="description" class="form-label">Comment</label>
                            <textarea
                                class="form-control"
                                id="description"
                                rows="1"
                                v-model="orderData.comment"
                            ></textarea>
                        </div>

                        <div class="col-md-12">
                            <label for="description" class="form-label">Attachment</label>
                            <ImageUploader ref="orderImageUploader" :orderId="orderData.id" />
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-outline-danger" @click="hideModal">Close</button>
                    <button
                        type="button"
                        class="btn btn-theme btn-sm"
                        :class="{'disabled': processing}"
                        :disabled="processing"
                        v-text="processing ? 'Processing...' : 'Update Task'"
                        @click="assignOrder"
                    ></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { appMixin } from '../../mixin/appMixin';
import ImageUploader from './ImageUploader.vue';
import BookingDatePicker from '../BookingDatePicker.vue';
import VueSelect from '../partials/VueSelect.vue';
import TimePicker from '../partials/TimePicker.vue';
export default {
    name: "AssignOrder",
    mixins: [appMixin],
    components: {
        ImageUploader,
        BookingDatePicker,
        VueSelect,
        TimePicker
    },
    props: {
        order: {
            type: Object,
            required: true
        },
        action: {
            type: String,
            default: "assign" // assign, reassign
        }
    },
    data() {
        return {
            processing: false,
            orderData: this.order,
            handymanList: [],
        }
    },
    mounted() {
        // Check if service_date is undefined then set it to booking_date
        if (this.orderData.service_date === undefined) {
            this.orderData.service_date = this.orderData.booking_date;
        }

        //Format the service_time
        let serviceTime = this.orderData.service_date || this.orderData.booking_date;
        this.orderData.service_time = {
            hours: this.momentObj(serviceTime).format('HH'),
            minutes: this.momentObj(serviceTime).format('mm')
        };

        // Set service type
        this.orderData.service_type = this.orderData.service_duration >= 8 ? 'full_day' : 'hours';

        //Set handyman ids
        this.orderData.handyman_id = this.orderData.handymans.map(handyman => handyman.id);

        // Default set comment empty
        this.orderData.comment = '';
    },
    watch: {
        'orderData.service_date': function(oldVal, newVal) {
            this.getHandymanAvailable();
        },
        'orderData.service_time': function(oldVal, newVal) {
            this.getHandymanAvailable();
        }
    },
    methods: {
        async getHandymanAvailable() {
            let params = {
                order_id: this.orderData.id,
                booking_date: this.orderData.service_date,
                start_time: this.orderData.service_time,
                end_time: {
                    hours: this.padZero(parseInt(this.orderData.service_time.hours) + parseInt(this.orderData.service_duration)),
                    minutes: this.orderData.service_time.minutes
                },
            };
            let users = await this.getHandymanForTaskAssignment(params);

            //Check if user is empty then empty the handyman_ids
            if (users.length == 0) {
                this.orderData.handyman_id = [];
            }
            //Prepare the options
            this.handymanList = users.map(user => ({
                id: user.id,
                text: user.name,
                name: user.name,
                email: user.email,
                temporary_booked: user.temporary_booked
            }));
        },
        onSelectHandyman(event) {
            // Check if temporary_booked is true then show alert
            if (event.temporary_booked) {
                Swal.fire({
                    text: `${event.name} is temporary booked for another task, are you sure you want to assign this task to ${event.name}?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, assign it!',
                    reverseButtons: true
                }).then((result) => {
                    if (!result.isConfirmed) {
                        // Then remove the id from the updateOrderData.handyman_id
                        this.orderData.handyman_id = this.orderData.handyman_id.filter(id => id !== event.id);
                    }
                });
            }
        },
        assignOrder() {
            // Firt check if handyman is empty then return
            if (this.orderData.handyman_id.length == 0) {
                this.$notification('error', "Please assign atleast one handyman to the order.");
                return;
            }

            // Prepare the handyman name
            let handymanNames = this.orderData.handyman_id.map(handymanId => {
                return this.handymanList.find(handyman => handyman.id == handymanId).name;
            });
            let nameString;
            if (handymanNames.length > 2) {
                // Join all but the last name with a comma, and append the last name with "and"
                nameString = `${handymanNames.slice(0, -1).join(', ')} and ${handymanNames[handymanNames.length - 1]}`;
            } else if (handymanNames.length === 2) {
                // If exactly two names, join with "and"
                nameString = handymanNames.join(' and ');
            } else {
                // If only one name, or none, no join needed
                nameString = handymanNames.join('');
            }


            let self = this;
            this.processing = true;

            const config = {
                headers: { "content-type": "multipart/form-data" },
            };
            // Prepare the comment
            let comment = this.orderData.comment || '';
            comment = (comment.length > 0 ? comment + " - " : "") + "(Reassigned to " + nameString + ")";

            let postData = {
                order_id: this.orderData.id,
                handyman_id: this.orderData.handyman_id,
                booking_date: this.momentObj(this.orderData.service_date).format('YYYY-MM-DD') + ' ' + this.padZero(this.orderData.service_time.hours) + ':' + this.padZero(this.orderData.service_time.minutes) + ':00',
                assigned_duration: this.orderData.service_duration,
                comment: comment,
                status: 'assigned',
                //order_type: this.orderData.order_type,
                files: this.$refs.orderImageUploader.files.map((file) => file.file)
            };

            axios.post('/admin/orders/assign', postData, config)
                .then(response => {
                    self.processing = false;
                    if(response.data.status == 'success') {
                        self.$emit('order-updated');
                        self.$notification(response.data.status,response.data.message);

                        // Clear the image uploader
                        self.$refs.orderImageUploader.clearFiles();

                        // Hide the modal
                        self.hideModal();

                        // Emit event to refresh the order list
                        self.$emitter.emit('refresh-order-list', {order: self.orderData});
                    }
                })
                .catch(error => {
                    self.processing = false;
                    self.$notification('error', error.response.data.message);
                })
                .finally(() => {
                    self.processing = false;
                });
        },
        showModal() {
            $('#assignOrderModal').modal('show');
        },
        hideModal() {
            $('#assignOrderModal').modal('hide');

            // Emit an event to reset the selected order
            this.$emitter.emit('reset-selected-order');
        }
    }
}
</script>
